import { AxiosRequestConfig } from 'axios';
import HTTP from 'libs/HTTP';

class FlowService extends HTTP {
  config: AxiosRequestConfig = {
    baseURL: this.config.baseURL + '/chatbot-server/api'
  };
  // 获取流程列表
  getList(data: any) {
    return this.get('/dialogFlows', data);
  }
  // 获取全部对话流列表
  getFlowList(data: any) {
    return this.get('/dialogFlows/list', data);
  }
  // 流程新增
  addFlow(data: any) {
    return this.post('/dialogFlows', data);
  }
  // 流程编辑
  updateFlow(id: any, data: any) {
    return this.put(`/dialogFlows/${id}`, data);
  }
  // 下线
  offLineFlow(flowId: any) {
    return this.put(`/dialogFlows/offline/${flowId}`);
  }
  // 删除流程
  deleteFlow(id: any) {
    return this.delete(`/dialogFlows/${id}`);
  }

  // 创建 下载流程节点 任务
  createDownloadNodeListTask(data: {
    flowId: string;
    botStatus: 'EDITING' | 'PUBLISHED';
  }) {
    return this.post('/dialogFlows/async/download/nodes', data);
  }
  // 查询 下载流程节点 任务 进度
  getDownloadNodeListResult(taskId: string) {
    return this.get('/dialogFlows/async/download/nodes/result', {
      taskId: taskId
    });
  }
  // 下载流程节点
  downloadNodeList(taskId: string) {
    return this.post(
      `/dialogFlows/async/download/nodes/excel?taskId=${taskId}`
    );
  }

  // 流程图编辑

  // 根据对话流flowId查询对话流流程图
  getFLowCanvas(id: string | number) {
    return this.get(`/dialogFlows/graph/flow/${id}`);
  }
  // 更新画布
  updateFlowCanvas(id: any, data: any) {
    return this.post(`/dialogFlows/graph/${id}`, data);
  }
  // 查询保存画布 是否已经保存 参数：flowKey:key
  // 如果返回 true 代表还没保存完，返回 false 代表已经保存完成
  getSaveResult(data: any) {
    return this.get(`/dialogFlows/query/save/result`, data);
  }
  // 保存到组件库
  saveToComponents(data: any) {
    return this.post(`/dialogFlows/component/save`, data);
  }
  // 组件库列表
  groupComponentsList(data: any) {
    return this.get(`/dialogComponents`, data);
  }
  // 删除组件
  deletegroupComponent(data: any) {
    return this.delete(`/dialogComponents/${data}`);
  }
  // 获取组件详情
  getGroupComponent(data: any) {
    return this.get(`/dialogComponents/${data}`);
  }
  // cell config 接口
  // demo test
  testFlow(id: any) {
    return this.post(`/dialogFlows/debug/prepare/${id}`);
  }
  // 测试 流程接口
  chat(data: any) {
    return this.post(`/dialogSessions/userInput`, data);
  }
  // 发布
  pushlishFlow(flowId: any) {
    return this.post(`/dialogFlows/publish/${flowId}`);
  }
}
export default new FlowService();
